/**
 * コンテンツ一括登録
 */

import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {
    Grid,
    InputBase,
    Typography,
    Button,
    List,
    ListItem,
    InputLabel,
    Fade,
    CircularProgress
} from '@material-ui/core';
import { dictionary, clientsInfo, cnfsystem } from 'mdoc/admin/axios'
import { getFilePath, contentCheck, contentMultipleUpload, contentUploadFile } from 'mdoc/admin/axios/content'
import Toast from 'mdoc/utils/toast';
import Dialog from 'mdoc/utils/myDialog';
import CustomizedTable from 'mdoc/utils/table'
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import eventProxy from 'mdoc/utils/eventProxy'

const styles = theme => ({
    appBarSpacer: theme.mixins.toolbar,
    margin: {
        margin: theme.spacing.unit,
    },
    bootstrapRoot: {
        'label + &': {
            marginTop: theme.spacing.unit * 3,
        },
        space: {
            height: theme.spacing.unit
        },
        minWidth: '50%'
    },
    bootstrapSelect: {
        backgroundColor: theme.palette.common.white,
        border: '1px solid #ced4da!important',
        paddingLeft: '5px'
    },
    error: {
        backgroundColor: 'red'
    },
    drop: {
        width: '298px'
    },
    buttonProgress: {
        color: '#ff0000',
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
        opacity: 0.5
    },
    fileInput: {
        display: 'none',
    },
    cusButton: {
        borderRadius: 0,
        boxShadow: 'none',
        backgroundColor: '#CED4DA',
        color: '#ffffff',
        maxWidth: '50%'
    },
    fileTips:{
        color: 'rgba(0, 0, 0, 0.54)',
        paddingTop: '5px'
    }
});

class Content_AllEdit extends React.Component {
    state = {
        selectedRowKeys: [], // Check here to configure the default column
        resultData: [],
        detailData: [],
        noPage: true,
        // loading: false,
        dictWord: {
            'csv_file_upload': '',
            'file_select': '',
            'registration_format': '',
            'registration': '',
            'cancel': '',
            'close': '',
            'folder_select': '',
            'msg_error_not_select_file': '',
            'upload_content_folder': '',
            'upload_csv_filename': '',
            'upload_result': '',
            'upload_detail': '',
            'book_title': '',
            'judge': '',
            'error_detail': '',
            'dimension_no': '',
            'upload_content': '',
            'confirmation': '',
            'msg_error_upload_file_type_invalid': '',
            'content_multiple_registration': '',
            'upload': '',
            'msg_error_not_found_file': '',
            'msg_error_file_count_match': '',
            'msg_error_file_name_match': '',
            'failed_count': '',
            'count': '',
            'max_file_size':'',
            'upload_only_files_type':'',
            'msg_error_file_size_over_length': '',
        },
        fileList: [],
        multipleList: [],
        fileName: '',
        folderName: '',
        uploadFileName: '',
        dialogOpen: false,
        uploadCheckErrorCount: '',
        count: '',
        errorCount: '',
        numberSeq: '',
        title: '',
        errorContents: '',
        judgment: '',
        error: '',
        pdfUpLoading: false,
        file_size:0,
        file_max_size:0,
    };
    componentWillMount() {
        this.start(this.state);
    }

    start = (state) => {
        let dict = {}
        dictionary(state.dictWord).then(res => {
            for (let key in res) {
                let val = res[key];
                dict[val.dictKey] = val.dictValue;
            }
            this.setState({
                dictWord: dict,
            })
        });
        cnfsystem("file_size").then(res => {
            let file_max_size = res * 1024 * 1024 * 1024;
            this.setState({
                file_size: res,
                file_max_size: file_max_size,
            })
        })
    }
    handleChange = (filed) => event => {
        this.setState({
            [filed]: Object.assign(this.state[filed], { value: event.target.value })
        });
    };
    //登録フォーマット
    fileFormat = () => {
        let dicWord = this.state.dictWord.content_multiple_registration
        getFilePath(dicWord + '.csv').then(res => {
        }).catch(function (error) {
            Toast.error(error);
        })
    }
   
    onFileDrop(event) {
        let me = this;
        let files = event.target.files || [];
        if (files.length < 1) return;
        let file = files[0];
        let name = file.name;
        let type = name.substr(name.lastIndexOf(".")).toLowerCase();//获得文件后缀名
        if (type.indexOf('csv') < 1) {
            Toast.error(me.state.dictWord['msg_error_upload_file_type_invalid']);
            return;
        }
        this.setState({
            fileName: name,
            fileList: files
        });
    }
    fileButton() {
        let fileInput = document.getElementById('button-file');
        fileInput.value = [];
    }
    mulFileButton() {
        let fileInput = document.getElementById('mulButton-file');
        fileInput.value = [];
    }
    onMultipleDrop(event) {
        let files = event.target.files || [];
        if (files.length < 1) return;
        let multipleList = this.state.multipleList;
        let fileNames = [];
        for (let key in multipleList) {
            let value = multipleList[key];
            fileNames.push(value.name);
        }
        let res = true;
        for (let index in files) {
            let item = files[index];
            if (typeof item !== 'object') continue;
            let name = item.name;
            let type = name.substr(name.lastIndexOf(".")).toLowerCase();
            if (['.pdf', '.mp4', '.epub'].indexOf(type) < 0) {
                res = false;
                break;
            }
            if (item.size > this.state.file_max_size) {
                Toast.error(this.state.dictWord['msg_error_file_size_over_length'].replace('%s', this.state.file_size));
                return;
            }
            if (fileNames.indexOf(item.name) < 0) {
                multipleList.push(item);
            }
        }
        if (!res) {
            Toast.error(this.state.dictWord['msg_error_upload_file_type_invalid']);
            return;
        }
        this.setState({
            multipleList: multipleList
        });
    }
    //アップロード
    fileUpload = () => {
        let fileList = this.state.fileList;
        let multipleList = this.state.multipleList;
        if (fileList.length < 1 || multipleList.length < 1) {
            Toast.info(this.state.dictWord.msg_error_not_select_file)
        } else {
            let data = new FormData();
            for (let key in fileList) {
                let item = fileList[key];
                if (typeof item === 'object') data.append("uploadFile", item);
            }
            this.setState({
                pdfUpLoading: true
            });
            let me = this;
            contentCheck(data).then(res => {
                let folderUuid = res.results.folderUuid
                let uploadCheckErrorCount = res.results.uploadCheckErrorCount
                let fileNames = res.results.fileNames;
                if (uploadCheckErrorCount > 0) {
                    this.setState({
                        dialogOpen: true,
                        uploadFileName: res.results.csvFileName,
                        count: res.results.uploadCheckCount,
                        errorCount: res.results.uploadCheckErrorCount,
                        detailData: res.results.uploadErrorDetails,
                        uploadCheckErrorCount: res.results.uploadCheckErrorCount,
                        multipleList: multipleList,
                        pdfUpLoading: false
                    });
                } else if (multipleList.length !== fileNames.length) {
                    Toast.info(this.state.dictWord['msg_error_file_count_match']);
                    me.setState({
                        pdfUpLoading: false
                    });
                } else {
                    let multipleList = this.state.multipleList;
                    let isInclude = false;
                    let errorFileName = [];
                    let successFileName = [];
                    for (var key in multipleList) {
                        let multipleListValue = multipleList[key]['name']
                        if (!fileNames.includes(multipleListValue)) {
                            isInclude = true;
                            errorFileName.push(multipleListValue);
                        } else {
                            successFileName.push(multipleListValue);
                        }
                    }
                    if (isInclude === true) {
                        let detailData = res.results.uploadErrorDetails;
                        let conunt = 0;
                        for (let key in detailData) {
                            if (!successFileName.includes(fileNames[key])) {
                                detailData[key]['judgment'] = 'NG';
                                detailData[key]['error'] = true;
                                detailData[key]['errorContents'] = this.state.dictWord['msg_error_file_name_match'];
                                conunt++;
                            }
                        }
                        this.setState({
                            dialogOpen: true,
                            uploadFileName: res.results.csvFileName,
                            count: res.results.uploadCheckCount,
                            errorCount: conunt,
                            detailData: detailData,
                            pdfUpLoading: false
                        });
                    }
                    if (isInclude === false) {
                        let data = new FormData();
                        for (let key in multipleList) {
                            let item = multipleList[key];
                            data.append("upfile", item)
                        }
                        contentMultipleUpload(folderUuid, data).then(mulRes => {
                            let folderUuid = mulRes.folderUuid
                            contentUploadFile(folderUuid).then(contentRes => {
                                clientsInfo().then(data => {
                                    eventProxy.trigger('uploadMultiple', data);
                                })
                                this.setState({
                                    dialogOpen: true,
                                    uploadFileName: res.results.csvFileName,
                                    count: res.results.uploadCheckCount,
                                    errorCount: res.results.uploadCheckErrorCount,
                                    detailData: res.results.uploadErrorDetails,
                                    uploadCheckErrorCount: res.results.uploadCheckErrorCount,
                                    multipleList: multipleList,
                                    pdfUpLoading: false
                                });
                            }).catch(function (error) {
                                Toast.error(error);
                                me.setState({
                                    pdfUpLoading: false
                                });
                            })
                        }).catch(function (error) {
                            Toast.error(error);
                            me.setState({
                                pdfUpLoading: false
                            });
                        })
                    }
                }
            }).catch(function (error) {
                Toast.error(error);
                me.setState({
                    pdfUpLoading: false
                });
            })
        }
    }
    deleteFile = (j) => event => {
        let multipleList = this.state.multipleList
        multipleList.splice(j, 1)
        this.setState({
            multipleList: multipleList
        })
    }
    dialogHandleOff = () => {
        this.setState({
            dialogEorrorOpen: false
        })
    }
    dialogHandleClose = () => {
        let uploadCheckErrorCount = this.state.uploadCheckErrorCount
        let errorCount = this.state.errorCount
        if (uploadCheckErrorCount > 0 || errorCount > 0) {
            this.setState({
                dialogOpen: false
            })
        } else {
            this.props.history.push('/admin/content/content');
        }
    }
    render() {
        const { classes } = this.props;
        const { dictWord } = this.state;
        const columnsDetail = [
            {
                title: this.state.dictWord.dimension_no,
                dataIndex: 'numberSeq',
            },
            {
                title: this.state.dictWord.book_title,
                dataIndex: 'title',
            },
            {
                title: this.state.dictWord.judge,
                dataIndex: 'judgment',
                render: (text, record) => {
                    if (record['judgment'] === 'NG') {
                        return <span className={classes.error}>NG</span>
                    } else {
                        return <span>OK</span>
                    }
                }
            },
            {
                title: this.state.dictWord.error_detail,
                dataIndex: 'errorContents',
            },
        ];
        return (
            <div className="mainDom" style={{ minWidth: '700px' }}>
                <div className={classes.appBarSpacer} />
                <Grid item xs={12} md={12}>
                    <Button variant="contained" color="primary" onClick={this.fileFormat} className={classes.margin}>
                        {this.state.dictWord.registration_format}
                    </Button>
                    <Button variant="contained" color="primary" onClick={this.fileUpload} className={classes.margin} disabled={this.state.pdfUpLoading}>
                        <Fade
                            in={this.state.pdfUpLoading}
                            style={{
                                transitionDelay: this.state.pdfUpLoading ? '800ms' : '0ms',
                            }}
                            unmountOnExit
                        >
                            <CircularProgress size={24} className={classes.buttonProgress} />
                        </Fade>
                        {dictWord.upload}
                    </Button>
                    <Button variant="contained" href={'/admin.html#/admin/content/content'} color="primary" className={classes.margin}>
                        {dictWord.cancel}
                    </Button>
                </Grid>
                <Typography variant="h5" gutterBottom className={classes.margin}>
                    {dictWord.csv_file_upload}
                </Typography>
                <Grid container className={classes.margin} >
                    <Grid item xs={12} md={3} style={{ maxWidth: '50%', minWidth: '450px' }}>
                        <input
                            accept=".csv"
                            className={classes.fileInput}
                            id="button-file"
                            type="file"
                            onChange={this.onFileDrop.bind(this)}
                        />
                        <label htmlFor="button-file">
                            <InputBase value={this.state.fileName} readOnly classes={{ root: classes.bootstrapRoot, input: classes.bootstrapSelect }} />
                            <Button variant="contained" component="span" color="default" className={classes.cusButton} onClick={this.fileButton.bind(this)}>
                                {dictWord.file_select}
                            </Button>
                        </label>
                    </Grid>
                </Grid>
                <Typography variant="h5" gutterBottom className={classes.margin}>
                    {dictWord.upload_content}
                </Typography>
                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={3} style={{ maxWidth: '50%', minWidth: '450px' }}>
                        <input
                            accept=".pdf,.epub,.mp4"
                            className={classes.fileInput}
                            id="mulButton-file"
                            type="file"
                            multiple
                            onChange={this.onMultipleDrop.bind(this)}
                        />
                        <label htmlFor="mulButton-file">
                            <InputBase readOnly classes={{ root: classes.bootstrapRoot, input: classes.bootstrapSelect, }} />
                            <Button variant="contained" component="span" color="default" className={classes.cusButton} onClick={this.mulFileButton.bind(this)}>
                                {dictWord.file_select}
                            </Button>
                        </label>
                        <div className={classes.fileTips}>
                        {dictWord.upload_only_files_type}<br />
                        {dictWord.max_file_size.replace('%s', this.state.file_size)}
                      </div>
                    </Grid>
                    
                </Grid>
                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={6}>
                        <List>
                            {this.state.multipleList.map((column, j) => {
                                return <ListItem key={j}>
                                    {column.name}
                                    <IconButton aria-label="Delete" onClick={this.deleteFile(j)}>
                                        <DeleteIcon />
                                    </IconButton>
                                </ListItem>
                            })}
                        </List>
                    </Grid>
                </Grid>
                <Dialog
                    open={this.state.dialogOpen}
                    option={{
                        close: {
                            text: this.state.dictWord['close'],
                        },
                        maxWidth: 'lg',
                    }}
                    title=""
                    content={
                        <div>
                            <Typography variant="h5" style={{ fontSize: '12px' }}>
                                {this.state.dictWord.upload_csv_filename}
                            </Typography>
                            <p>{this.state.uploadFileName}</p>
                            <Grid container className={classes.margin}>
                                <Grid item xs={12} md={12}>
                                    <Typography variant="h5" style={{ fontSize: '12px' }}>
                                        {this.state.dictWord.upload_result}
                                    </Typography>
                                    <Grid container className={classes.margin}>
                                        <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                                            <InputLabel shrink htmlFor="">
                                                {this.state.dictWord.count}
                                            </InputLabel>
                                        </Grid>
                                        <Grid item xs={12} md={2}>
                                            <span>{this.state.count}</span>
                                        </Grid>
                                    </Grid>
                                    <Grid container className={classes.margin}>
                                        <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                                            <InputLabel shrink htmlFor="">
                                                {this.state.dictWord.failed_count}
                                            </InputLabel>
                                        </Grid>
                                        <Grid item xs={12} md={2}>
                                            <span>{this.state.errorCount}</span>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <div>
                                <Grid item xs={12} md={12}>
                                    <Typography variant="h5" style={{ fontSize: '12px' }}>
                                        {this.state.dictWord.upload_detail}
                                    </Typography>
                                    <Typography component="div" className={classes.tableContainer}>
                                        <CustomizedTable
                                            data={this.state.detailData}
                                            noPage={this.state.noPage}
                                            columns={columnsDetail}
                                        />
                                    </Typography>
                                </Grid>
                            </div>
                        </div>
                    }
                    handleClose={this.dialogHandleClose}
                />
            </div>
        )
    }
}

Content_AllEdit.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Content_AllEdit);